import { gql } from "@apollo/client"

export const GET_USER_ORG_JOIN_REQUEST = gql`
  query getUserJoinRequest {
    myUser {
      joinRequests {
        id
        fromUser {
          id
          email
        }
        toUser
        organization {
          id
          name
        }
      }
    }
  }
`
